import { render, staticRenderFns } from "./TjingSidebar.vue?vue&type=template&id=07f8b983&scoped=true"
import script from "./TjingSidebar.vue?vue&type=script&lang=js"
export * from "./TjingSidebar.vue?vue&type=script&lang=js"
import style0 from "./TjingSidebar.vue?vue&type=style&index=0&id=07f8b983&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f8b983",
  null
  
)

export default component.exports